import { combineReducers } from 'redux';
import { RESET_NON_PERSISTENT_COLLEGE_PROFILE } from '../constants';
import media from './media';
import linksAndProfiles from './linksAndProfiles';
import intro from './intro';

const nonPersistentReducers = combineReducers({
  media,
  linksAndProfiles,
  intro,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_NON_PERSISTENT_COLLEGE_PROFILE) {
    state = undefined;
  }
  return nonPersistentReducers(state, action);
};

export default rootReducer;
